export default __webpack_public_path__ + "static/fonts/BrotherHome.f418d99.woff2";